import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Tomos() {
  const tomos = [{
    num: 'MÓDULO 1',
    title: 'Los Orígenes de la Antigua Grecia',
    desc: 'Conoce el nacimiento de la civilización griega, sus primeras culturas, el surgimiento de las polis, la democracia, la filosofía y las bases de una sociedad que cambió el mundo.'
  }, {
    num: 'MÓDULO 2',
    title: 'Dioses, Titanes y el Monte Olimpo',
    desc: 'Descubre el origen del universo según la mitología griega, la historia de los Titanes y conoce a los doce dioses olímpicos, sus poderes, símbolos y leyendas.'
  }, {
    num: 'MÓDULO 3',
    title: 'Héroes y Grandes Leyendas',
    desc: 'Explora las increíbles aventuras de Aquiles, Heracles, Perseo, Odiseo, Jasón, Teseo y otros héroes cuyas historias siguen inspirando al mundo.'
  }, {
    num: 'MÓDULO 4',
    title: 'Monstruos y Criaturas Mitológicas',
    desc: 'Adéntrate en el universo de Medusa, Cerbero, Pegaso, Hidra, Minotauro, Quimera, Sirenas, Centauros y muchas criaturas legendarias.'
  }, {
    num: 'MÓDULO 5',
    title: 'Misterios, Secretos y Enigmas',
    desc: 'Descubre los grandes enigmas de la Antigua Grecia: el Oráculo de Delfos, la Atlántida, el Caballo de Troya, rituales sagrados y los secretos que aún hoy generan debate.'
  }, {
    num: 'MÓDULO 6',
    title: 'El Legado de Grecia',
    desc: 'Comprende cómo la filosofía, la democracia, la ciencia, el arte, la literatura y la cultura griega siguen presentes en nuestra vida cotidiana.'
  }];
  const includes = ['Ilustraciones cinematográficas', 'Mapas históricos', 'Infografías detalladas', 'Curiosidades y relatos', 'Formato 100% digital'];
  return <section className="py-20 md:py-32 px-4 relative" data-id="element-269">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/20 to-transparent" data-id="element-270" />

      <div className="max-w-6xl mx-auto" data-id="element-271">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-272">
          <div className="inline-block mb-4" data-id="element-273">
            <span className="text-gold text-4xl" data-id="element-274">🏛️</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-6 text-white" data-id="element-275">
            Todo lo que incluye Grecia Legendaria
          </h2>
          <p className="text-xl text-gold-light font-medium mb-2" data-id="element-276">
            6 módulos cuidadosamente desarrollados + 4 bonos exclusivos
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-16" data-id="element-277">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-dark-card border border-dark-border p-8 rounded-xl hover:border-gold/40 transition-all group relative overflow-hidden" data-id="element-278">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gold/5 rounded-bl-full -mr-16 -mt-16 transition-transform group-hover:scale-110" data-id="element-279" />

              <div className="text-gold font-bold text-sm tracking-widest mb-2" data-id="element-280">
                {tomo.num}
              </div>
              <h4 className="text-2xl font-heading font-bold text-white mb-4" data-id="element-281">
                {tomo.title}
              </h4>
              <p className="text-gray-300 leading-relaxed relative z-10" data-id="element-282">
                {tomo.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-dark-lighter border border-dark-border rounded-2xl p-8 md:p-12 max-w-4xl mx-auto" data-id="element-283">
          <h4 className="text-xl font-bold text-white mb-8 text-center" data-id="element-284">
            Cada módulo incluye:
          </h4>
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-4" data-id="element-285">
            {includes.map((item, index) => <div key={index} className="flex items-center gap-3" data-id="element-286">
                <CheckCircle2 className="w-5 h-5 text-gold shrink-0" data-id="element-287" />
                <span className="text-gray-200 font-medium" data-id="element-288">{item}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}